import React, { InputHTMLAttributes, useEffect, useRef } from 'react';
import { useField } from '@unform/core';

import { Container } from './styles';

interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  name: string;
  checked?: boolean;
  placeholder?: string;
  containerStyle?: {};
}

const InputCheckbox: React.FC<InputProps> = ({
  name,
  checked,
  placeholder,
  containerStyle,
  ...rest
}) => {
  const inputRef = useRef<HTMLInputElement>(null);

  const { fieldName, defaultValue, error, registerField } = useField(name);

  useEffect(() => {
    registerField({
      name: fieldName,
      ref: inputRef.current,
      path: 'checked',
    });
  }, [fieldName, registerField]);

  return (
    <Container isErrored={!!error} style={containerStyle}>
      <input
        type="checkbox"
        defaultChecked={checked}
        defaultValue={defaultValue}
        ref={inputRef}
        {...rest}
      />

      <label>{placeholder}</label>
    </Container>
  );
};

export default InputCheckbox;
